export const NAMES_MAP = {
  MegaTroll: "T",
  zipline: "X",
};
